import firebase from "firebase";

export class Ristorante {
    documentId: string;
    aperto: boolean;
    categorie: string[];
    collaboratoriCassa: string[];
    collaboratoriCucina: string[];
    confermaOrdini: number;
    coperti: number;
    descrizione: string;
    doppiaVerifica: boolean;
    email: string;
    g: string;
    l: firebase.firestore.GeoPoint;
    logoLink: string;
    nome: string;
    numeroDiTelefono: string;
    onlinePayment: number;
    orari: Orari[];
    pagamenti: Pagamenti;
    patternOrari: PatternOrari[];
    prenotazioni: Prenotazioni;
    sfondoLink: string;
    subType: number;
    tipologie: Tipologie[];
    userID: string;
    visible: boolean;

    constructor() {
        this.documentId = "";
        this.aperto = false;
        this.categorie = [];
        this.collaboratoriCassa = [];
        this.collaboratoriCucina = [];
        this.confermaOrdini = 0;
        this.coperti = 0;
        this.descrizione = '';
        this.doppiaVerifica = false;
        this.email = '';
        this.g = '';
        this.l = new firebase.firestore.GeoPoint(0, 0);
        this.logoLink = '';
        this.nome = '';
        this.numeroDiTelefono = '';
        this.onlinePayment = 0;
        this.orari = [];
        this.pagamenti = new Pagamenti();
        this.patternOrari = [];
        this.prenotazioni = new Prenotazioni();
        this.sfondoLink = '';
        this.subType = 0;
        this.tipologie = [];
        this.userID = '';
        this.visible = false;
    }


    static convertFromFirestore(documentId: string, object: firebase.firestore.DocumentData): Ristorante {
        let result: Ristorante = new Ristorante();
        result.documentId = documentId;
        result.aperto = object.aperto;
        result.categorie = object.categorie;
        result.collaboratoriCassa = object.collaboratoriCassa;
        result.collaboratoriCucina = object.collaboratoriCucina;
        result.confermaOrdini = object.confermaOrdini;
        result.coperti = object.coperti;
        result.descrizione = object.descrizione;
        result.doppiaVerifica = object.doppiaVerifica;
        result.email = object.email;
        result.g = object.g;
        result.l = object.l;
        result.logoLink = object.logoLink;
        result.nome = object.nome;
        result.numeroDiTelefono = object.numeroDiTelefono;
        result.onlinePayment = object.onlinePayment;
        result.orari = object.orari;
        result.pagamenti = object.pagamenti;
        result.patternOrari = object.patternOrari;
        result.prenotazioni = object.prenotazioni;
        result.sfondoLink = object.sfondoLink;
        result.subType = object.subType;
        result.tipologie = object.tipologie.map((tipologiaFirebase: firebase.firestore.DocumentData) => Tipologie.convertFromFirestore(tipologiaFirebase));
        result.userID = object.userID;
        result.visible = object.visible;
        return result;
    }

    static convertToFirestore(object: Ristorante): firebase.firestore.DocumentData {
        let result: firebase.firestore.DocumentData = {};
        result.aperto = object.aperto;
        result.categorie = object.categorie;
        result.collaboratoriCassa = object.collaboratoriCassa;
        result.collaboratoriCucina = object.collaboratoriCucina;
        result.confermaOrdini = object.confermaOrdini;
        result.coperti = object.coperti;
        result.descrizione = object.descrizione;
        result.doppiaVerifica = object.doppiaVerifica;
        result.email = object.email;
        result.g = object.g;
        result.l = object.l;
        result.logoLink = object.logoLink;
        result.nome = object.nome;
        result.numeroDiTelefono = object.numeroDiTelefono;
        result.onlinePayment = object.onlinePayment;
        result.orari = object.orari;
        result.pagamenti = object.pagamenti;
        result.patternOrari = object.patternOrari;
        result.prenotazioni = object.prenotazioni;
        result.sfondoLink = object.sfondoLink;
        result.subType = object.subType;
        result.tipologie = object.tipologie;
        result.userID = object.userID;
        result.visible = object.visible;
        return result;
    }
}

class Orari {
    aperture: Aperture[];
    giorno: boolean;
    nomePattern: string;
    orariDouble: boolean;

    constructor() {
        this.aperture = [];
        this.giorno = false;
        this.nomePattern = '';
        this.orariDouble = false;
    }
}

class Aperture {
    minuti: number;
    ore: number;

    constructor() {
        this.minuti = 0;
        this.ore = 0;
    }
}

class Pagamenti {
    modalita: number[];
    pagamentoMinimo: number;
    tipologia: number;

    constructor() {
        this.modalita = [];
        this.pagamentoMinimo = 0;
        this.tipologia = 0;
    }
}

class PatternOrari {
    nome: string;
    orario: Orario[];

    constructor() {
        this.nome = '';
        this.orario = [];
    }
}

class Orario {
    minuti: number;
    ore: number;

    constructor() {
        this.minuti = 0;
        this.ore = 0;
    }
}

class Prenotazioni {
    gruppiTavoli: any[];
    impostazioni: Impostazioni;
    isEnabled: boolean;
    moreTavoli: boolean;
    tipoDiPrenotazione: number;

    constructor() {
        this.gruppiTavoli = [];
        this.impostazioni = new Impostazioni();
        this.isEnabled = false;
        this.moreTavoli = false;
        this.tipoDiPrenotazione = 0;
    }
}

class Impostazioni {
    confirmEmail: boolean;
    permanenza: { ore: number, minuti: number };
    prima: { ore: number, minuti: number };

    constructor() {
        this.confirmEmail = false;
        this.permanenza = {
            ore: 0,
            minuti: 0
        };
        this.prima = {
            ore: 0,
            minuti: 0
        };
    }
}

class Tipologie {
    hasPass: boolean;
    nome: string;

    constructor() {
        this.hasPass = false;
        this.nome = '';
    }

    static convertFromFirestore(object: firebase.firestore.DocumentData): Tipologie {
        let result: Tipologie = new Tipologie();
        result.hasPass = object.has_pass;
        result.nome = object.nome;
        return result;
    }

    static convertToFirestore(object: Tipologie): firebase.firestore.DocumentData {
        let result: firebase.firestore.DocumentData = {};
        result.has_pass = object.hasPass;
        result.nome = object.nome;
        return result;
    }
}